type Props = {
  className?: string;
};

const IconTick = (props: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="22"
    viewBox="0 0 23 22"
    fill="none"
    className={props.className}
  >
    <path
      d="M11.3335 21C12.647 21.0016 13.9478 20.7437 15.1613 20.2411C16.3747 19.7384 17.4769 19.0009 18.4045 18.071C19.3344 17.1434 20.0719 16.0412 20.5745 14.8278C21.0772 13.6143 21.3351 12.3135 21.3335 11C21.3351 9.68655 21.0772 8.38572 20.5745 7.17225C20.0719 5.95878 19.3344 4.85659 18.4045 3.92901C17.4769 2.99909 16.3747 2.26162 15.1613 1.75897C13.9478 1.25631 12.647 0.998388 11.3335 1.00001C10.02 0.998388 8.71922 1.25631 7.50575 1.75897C6.29228 2.26162 5.19009 2.99909 4.2625 3.92901C3.33258 4.85659 2.59511 5.95878 2.09246 7.17225C1.58981 8.38572 1.33188 9.68655 1.3335 11C1.33188 12.3135 1.58981 13.6143 2.09246 14.8278C2.59511 16.0412 3.33258 17.1434 4.2625 18.071C5.19009 19.0009 6.29228 19.7384 7.50575 20.2411C8.71922 20.7437 10.02 21.0016 11.3335 21Z"
      stroke="#BEBEBE"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M7.3335 11L10.3335 14L16.3335 8"
      stroke="#BEBEBE"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IconTick;
